// extracted by mini-css-extract-plugin
export default {"container":"SelectPanel_container__AWAh0"};